import { useContext } from "react";
import { BiChevronLeft } from 'react-icons/bi';
import CompanyContext from "../../contexts/companyContext";
import { useAppRouter } from "../../hooks/useAppRouter";
import './css/returnButton.css';



export default function ReturnButton (props) {
    const navigate = useAppRouter();
    const {companyData} = useContext(CompanyContext);

    return (
        <button className="return-button" style={{ backgroundColor: companyData.text_color, paddingRight: props.showText ? 10 : 5 }} onClick={() => props.action ? props.action() : navigate(-1)}>
            <BiChevronLeft size={24} color={companyData.background_color} />
            {props.showText && (
                <span style={{ color: companyData.background_color }}>Voltar</span>
            )}
        </button>
    )
}